import React, { useState } from 'react';
import jsPDF from 'jspdf';
import EmployeeDischarge from './EmployeeDischarge';
import NewDischargePopup from './NewDischargePopup';

interface Employee {
  name: string;
  date: string;
  descargo: string;
  signature: string;
  evidenceFile?: File;
}

const EmployeeDischargeList: React.FC = () => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleNewDischarge = (name: string, date: string, descargo: string, signature: string, evidenceFile?: File) => {
    const newEmployee: Employee = { name, date, descargo, signature, evidenceFile };
    setEmployees([...employees, newEmployee]);
    setIsPopupOpen(false);
  };

  const handleGeneratePDF = (employee: Employee) => {
    const doc = new jsPDF();

    doc.text(`Nombre: ${employee.name}`, 10, 10);
    doc.text(`Fecha: ${employee.date}`, 10, 20);
    doc.text(`Descargo: ${employee.descargo}`, 10, 30);
    doc.addImage(employee.signature, 'PNG', 10, 40, 180, 60);

    if (employee.evidenceFile) {
      const reader = new FileReader();
      reader.onload = function(event) {
        const result = event.target?.result as string;
        if (result) {
          doc.addPage();
          doc.text('Evidencia:', 10, 10);
          doc.addImage(result, 'PNG', 10, 20, 180, 160);
          doc.save(`${employee.name}_descargo.pdf`);
        }
      };
      reader.readAsDataURL(employee.evidenceFile);
    } else {
      doc.save(`${employee.name}_descargo.pdf`);
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-xl font-semibold mb-4">Descargos Laborales</h1>
      <button
        onClick={() => setIsPopupOpen(true)}
        className="mb-4 bg-blue-500 text-white px-4 py-2 rounded"
      >
        Crear Nuevo Descargo
      </button>
      {employees.map((employee, index) => (
        <div key={index} className="bg-white shadow-md rounded p-4 mb-4">
          <EmployeeDischarge employee={employee} />
          <button
            onClick={() => handleGeneratePDF(employee)}
            className="mt-2 bg-green-500 text-white px-4 py-2 rounded"
          >
            Generar PDF
          </button>
        </div>
      ))}
      {isPopupOpen && <NewDischargePopup onClose={() => setIsPopupOpen(false)} onSave={handleNewDischarge} />}
    </div>
  );
};

export default EmployeeDischargeList;
